import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { buildFleetQuery } from '../_shared/utils/fleet-query';

@Injectable({
  providedIn: 'root'
})
export class FleetChargingFigureService {
  
  constructor(private readonly httpClient: HttpClient) { }
  
  getChargedEnergyFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'charged-energy-time-fleet?' + buildFleetQuery(fleetId, batteryType));
  }
  
  getSocDeltaFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'soc-difference-charging-session-fleet?' + buildFleetQuery(fleetId, batteryType));
  }
  
  getFullChargeCyclesFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'full-charge-cycles-fleet?' + buildFleetQuery(fleetId, batteryType));
  }
  
  getStateOfChargeEventsFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'state-of-charge-events-fleet?' + buildFleetQuery(fleetId, batteryType));
  }
  
  getStateOfChargeFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'state-of-charge-fleet?' + buildFleetQuery(fleetId, batteryType));
  }
  getChargedEnergyFleetEF(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'charged-energy-ef?' + buildFleetQuery(fleetId, batteryType));
  }
}
